import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';

const CustomStepIcon = (props) => {
  const { icon, active, completed } = props;

  const color = completed || active ? '#1b1914' : 'grey.500';

  return (
    <Box
      sx={{
        backgroundColor: completed || active ? "#1b1914" : "grey.500",
        width: 25,
        height: 25,
        borderRadius: '50%',
        // border: '2px solid',
        // borderColor: color,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
      }}
    >
      <Typography variant="body2" >{completed ? <Check fontSize="small" sx={{mt:0.8}} /> : (icon || null)}</Typography>
    </Box>
  );
};

export default CustomStepIcon;
